/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import {
    MarkdownContent,
    Section,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import ImageModal from '../ImageModal';

import styles from './AirportOverview.scss';

const propTypes = {
    airportImages: PropTypes.array,
    description: PropTypes.string,
    namespace: PropTypes.string,
    title: PropTypes.string,
};

const defaultProps = {
    airportImages: [],
    description: '',
    namespace: '',
    title: '',
};

const AirportOverview = (props) => {
    const {
        description,
        id,
        namespace,
        airportImages,
        t,
        title,
    } = props;

    const [imageToDisplay, setImageToDisplay] = useState();

    function dismissModal() {
        setImageToDisplay(undefined);
    }

    function showModal(index) {
        setImageToDisplay(index);
    }

    return (
        <Section id={id}>
            {imageToDisplay !== undefined && (
                <ImageModal
                    dismissModal={dismissModal}
                    image={airportImages[imageToDisplay]}
                />
            )}
            <div className={styles.terminalContainer}>
                <div className={styles.terminalText}>
                    <div className={styles.about}>
                        <Typography variant="h3">{t(`${namespace}:${title}`)}</Typography>
                        <Typography
                            component={MarkdownContent}
                            paragraph
                        >
                            {t(`${namespace}:${description}`)}
                        </Typography>
                    </div>
                </div>
                <div className={styles.images}>
                    {airportImages.map((image, index) => (
                        <img
                            alt={image?.metadata?.alt || ''}
                            className={styles.terminalImg}
                            key={image.url}
                            onClick={() => showModal(index)}
                            src={image.url}
                            title={image?.metadata?.alt || ''}
                        />
                    ))}
                </div>
            </div>
        </Section>
    );
};

AirportOverview.propTypes = propTypes;
AirportOverview.defaultProps = defaultProps;

export { AirportOverview };
export default localize(AirportOverview);
